<div
  style="
    overflow-y: auto;
    overflow-x: hidden;
    height: 40vh !important;
    padding: 6px 0;
    display: flex;
    flex-direction: column;
  "
>
  <app-loading *ngIf="!dataLoaded"></app-loading>
  <div *ngIf="dataLoaded" style="flex: 1">
    <div *ngIf="ideaData">
      <app-tag
        [dataObj]="getTagObject()"
        [tagsIds]="ideaData.tag_ids"
      ></app-tag>
    </div>
    <div *ngIf="!ideaData">
      <app-tag
        [noIds]="true"
        [tagsIds]="ideaTags"
        (childTags)="getChildTags($event)"
      ></app-tag>
    </div>
    <form [formGroup]="newForm">
      <div class="row mt-3">
        <div class="col-sm-12">
          <mat-form-field appearance="outline" class="w-100 px-1">
            <mat-label>Idea Pitch Title</mat-label>
            <input matInput formControlName="title" required />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100 px-1">
            <mat-label>Description</mat-label>
            <textarea
              matInput
              rows="4"
              formControlName="description"
              required
            ></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100 px-1">
            <mat-label>Vendor</mat-label>
            <mat-select formControlName="vendor_id">
              <mat-option *ngFor="let x of serviceProviders" [value]="x.id">
                <img
                  src="{{ x.url }}"
                  style="
                    width: 35px;
                    height: 35px;
                    object-fit: cover;
                    margin-right: 10px;
                  "
                  alt="img"
                />{{ x.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-50 pe-2">
            <mat-label>{{ displayLabels.portfolio }}</mat-label>
            <input
              matInput
              [matAutocomplete]="auto"
              type="text"
              formControlName="portfolio"
              required
            />
            <mat-icon matSuffix class="muted">search</mat-icon>
            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayFnName"
            >
              <mat-option
                *ngFor="let option of filterOptionPortfolio | async"
                [value]="option"
                (onSelectionChange)="onSelectionChangePortfolio($event)"
              >
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-50 ps-2">
            <mat-label>{{ displayLabels.sub_portfolio }}</mat-label>
            <input
              matInput
              [matAutocomplete]="auto1"
              type="text"
              formControlName="subPortfolio"
              required
            />
            <mat-icon matSuffix class="muted">search</mat-icon>
            <mat-autocomplete
              #auto1="matAutocomplete"
              [displayWith]="displayFnName"
            >
              <mat-option
                *ngFor="let option of filterOptionSubPortfolio | async"
                [value]="option"
                (onSelectionChange)="onSelectionChangeSubportPortfolio($event)"
              >
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-50 pe-2">
            <mat-label>{{ displayLabels.program }}</mat-label>
            <input
              matInput
              [matAutocomplete]="auto5"
              type="text"
              formControlName="program"
              required
            />
            <mat-icon matSuffix class="muted">search</mat-icon>
            <mat-autocomplete
              #auto5="matAutocomplete"
              [displayWith]="displayFnName"
            >
              <mat-option
                *ngFor="let option of filterOptionProgram | async"
                [value]="option"
              >
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-50 ps-2">
            <mat-label>Owner</mat-label>
            <input
              matInput
              type="text"
              readonly
              formControlName="owners"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-50 pe-2">
            <mat-label>Impact</mat-label>
            <input matInput formControlName="impact" required />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-50 ps-2">
            <mat-label>Tech stack</mat-label>
            <input matInput formControlName="technologies" required />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>POC expectations</mat-label>
            <textarea
              matInput
              rows="3"
              formControlName="poc_expectations"
              required
            ></textarea>
          </mat-form-field>

          <h6 class="mt-2">Attach File</h6>
          <mat-accordion>
            <mat-expansion-panel
              [expanded]="true"
              (opened)="panelOpenState = true"
              (closed)="panelOpenState = false"
              style="border-radius: 20px"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Attachments ({{
                    fileControls.controls.length +
                      ideaData?.idea_pitch_files?.length | appFormat : "number"
                  }})

                  <button
                    [hidden]="isBaselined"
                    mat-icon-button
                    color="success"
                    class="bwo"
                  >
                    <input
                      hidden
                      #fileInput
                      type="file"
                      id="file"
                      (change)="onFileSelected($event)"
                    />
                    <mat-icon (click)="fileInput.click()">add</mat-icon>
                  </button>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div style="padding: 20px; overflow-x: scroll">
                <div
                  class="d-flex flex-row flex-nowrap overflow-auto"
                  style="padding: 10px 0"
                >
                  <div
                    class="card card-block mx-2"
                    style="
                      width: 150px;
                      height: 150px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 15px;
                    "
                    *ngFor="let x of ideaData?.idea_pitch_files; let i = index"
                  >
                    <div class="me-2 mt-2">
                      <mat-icon
                        mat-list-icon
                        class="material-icons my-auto fs-1 text-danger"
                      >
                        description</mat-icon
                      >
                    </div>
                    <p class="m-0 ellipsis-text" [matTooltip]="x.file_name">
                      {{ x?.file_name }}
                    </p>
                    <mat-icon
                      color="remove"
                      [hidden]="isBaselined"
                      (click)="deleteFile(x?.id)"
                      >clear</mat-icon
                    >
                  </div>
                  <div
                    class="card card-block mx-2"
                    style="
                      width: 150px;
                      height: 150px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 15px;
                    "
                    *ngFor="let x of fileControls.controls; let i = index"
                  >
                    <div class="me-2 mt-2">
                      <mat-icon
                        mat-list-icon
                        class="material-icons my-auto fs-1 text-danger"
                      >
                        description</mat-icon
                      >
                    </div>
                    <p
                      class="m-0 ellipsis-text"
                      style="width: 60%; text-align: center"
                      [matTooltip]="x.value.name"
                    >
                      {{ x?.value?.name }}
                    </p>
                    <mat-icon
                      color="remove"
                      [hidden]="isBaselined"
                      (click)="removeFile(i)"
                      >clear</mat-icon
                    >
                  </div>
                  <div
                    *ngIf="
                      fileControls.controls.length == 0 &&
                      ideaData?.idea_pitch_files.length == 0
                    "
                    class="d-flex w-100 justify-content-center"
                  >
                    {{ commonText.no_files_attached }}
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <h6 class="mt-4">Link</h6>
          <div class="row">
            <div class="col-sm-10">
              <mat-form-field appearance="outline" class="w-100 px-1">
                <mat-label>Link URL</mat-label>
                <input
                  matInput
                  [(ngModel)]="linkURL"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="isBaselined"
                />
              </mat-form-field>
            </div>
            <div
              class="col-sm-1"
              style="display: flex; justify-content: space-between"
            >
              <button
                mat-icon-button
                color="success"
                [hidden]="isBaselined"
                (click)="addLink()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <mat-accordion>
            <mat-expansion-panel
              [expanded]="true"
              (opened)="panelOpenState = true"
              (closed)="panelOpenState = false"
              style="border-radius: 20px"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Links ({{ linksControls.length | appFormat : "number" }})
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div style="overflow-x: scroll; padding: 20px">
                <div
                  class="d-flex flex-row flex-nowrap overflow-auto"
                  style="padding: 10px 0"
                >
                  <div
                    class="card card-block mx-2"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: end;
                      border-radius: 15px;
                      cursor: pointer;
                    "
                    *ngFor="let ctrl of linksControls.controls; let i = index"
                    (click)="openLink(ctrl.value)"
                  >
                    <div class="d-flex align-items-center">
                      <mat-icon class="lk">link</mat-icon>
                      <p class="m-0 asw">{{ ctrl.value }}</p>
                      <mat-icon
                        color="remove"
                        [hidden]="isBaselined"
                        (click)="removeLink(i)"
                        >clear</mat-icon
                      >
                    </div>
                  </div>
                  <div
                    *ngIf="linksControls.length == 0"
                    class="d-flex w-100 justify-content-center"
                  >
                    {{ commonText.no_links_attached }}
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="d-flex justify-content-end mt-4">
  <button
    mat-stroked-button
    mat-button
    color="warn"
    class="me-1"
    aria-label="reject"
    (click)="rejectIdea()"
    *ngIf="
      ideaData?.accelerator?.status != 'create_turnkey' &&
      ideaData?.accelerator?.status != 'create_opportunity'
    "
  >
    Reject
  </button>
  <button
    mat-button
    mat-flat-button
    [hidden]="isBaselined"
    color="primary"
    aria-label="submit"
    [disabled]="newForm.invalid"
    (click)="submitData('in accelerator')"
  >
    Baseline
  </button>
  <button
    mat-button
    mat-flat-button
    color="primary"
    [hidden]="!isBaselined"
    (click)="goToUnderCommercials()"
  >
    Next
  </button>
</div>
